import joi from 'joi';
import { localizedPropertySchema } from '../utils';

export const $rewardI18nAttribute = joi.object({
  name: joi.string().trim().empty('').max(200).required(),
  description: joi.string().empty('').optional(),
  image: joi.string(),
  details: joi.string().empty('').optional(),
  detailsLabel: joi.string().empty('').optional(),
});

export const $rewardsI18nextAttributes = localizedPropertySchema($rewardI18nAttribute).required();
